import { ReduxService } from 'dashboard-services/services';

import { settingsSeriesActions } from 'actions/series';
import { LocalStorageUtils } from 'utils';

export const getSettingsInitialState = () => ReduxService.updateObject(settingsSeriesActions.defaultState, LocalStorageUtils.getTsDefaultSettings())

export default (state = getSettingsInitialState(), action) => {
  switch (action.type) {
    case settingsSeriesActions.ON_CHANGE: {
      if(action.name === "formulaExpressions") {
        return ReduxService.updateObject(state, { formulaExpressions: action.value })
      }
      const formulaExpressions = { ...(state.formulaExpressions || {}) }
      if(formulaExpressions[action.name]) {
        delete formulaExpressions[action.name]
      }
      return ReduxService.updateObject(state, { [action.name]: action.value, formulaExpressions })
    }
    case settingsSeriesActions.CLEAR: 
      return getSettingsInitialState();
    default:
      return state;
  }
}
